import { Routes, Route, Navigate } from "react-router-dom";
import Citas from "../features/appointments/pages/Citas";
import Agenda from "../features/appointments/pages/Agenda";
import Pacientes from "../features/appointments/pages/Pacientes";
import PacientePerfil from "../features/appointments/pages/PacientePerfil";
import TiposCita from "../features/appointments/pages/TiposCita";
import Administrar from "../features/appointments/pages/Administrar";
import Login from "../features/auth/pages/Login";
import Perfil from "../features/auth/pages/Perfil";
import OlvidePassword from "../features/auth/pages/OlvidePassword";
import ResetPassword from "../features/auth/pages/ResetPassword";
import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "../routes/PrivateRoute";
import ApiErrorModal from "../shared/components/ApiErrorModal";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to={localStorage.getItem("token") ? "/citas" : "/login"} replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/olvide-password" element={<OlvidePassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/agenda"
          element={
            <PrivateRoute>
              <DashboardLayout><Agenda /></DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/citas"
          element={
            <PrivateRoute>
              <DashboardLayout><Citas /></DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/pacientes"
          element={
            <PrivateRoute>
              <DashboardLayout><Pacientes /></DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/pacientes/:id/perfil"
          element={
            <PrivateRoute>
              <DashboardLayout><PacientePerfil /></DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/tiposcita"
          element={
            <PrivateRoute>
              <DashboardLayout><TiposCita /></DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/administrar"
          element={
            <PrivateRoute>
              <DashboardLayout><Administrar /></DashboardLayout>
            </PrivateRoute>
          }
        />
        <Route
          path="/perfil"
          element={
            <PrivateRoute>
              <DashboardLayout><Perfil /></DashboardLayout>
            </PrivateRoute>
          }
        />
      </Routes>
      <ApiErrorModal />
    </>
  );
}
